import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import {
  Container,
  Table,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  getNotifications,
  fetchNotifications,
  markNotificationAsRead,
  markNotificationAsUnread,
  deleteNotification,
} from '../actions/Notifications';

import NotificationsHeader from '../components/Notifications/Header';
import NotificationsItem from '../components/Notifications/Item';

import Loading from '../components/Loading';
import NothingFound from '../components/NothingFound';

const Notifications = ({
  dispatch,
  notifications,
  notificationsLoading,
}) => {
  const intl = useIntl();

  const loadMore = () => {
    dispatch(getNotifications([]));
    dispatch(fetchNotifications());
  };

  const handleMarkAsRead = (notificationId) => {
    dispatch(markNotificationAsRead(notificationId));
  };

  const handleMarkAsUnread = (notificationId) => {
    dispatch(markNotificationAsUnread(notificationId));
  };

  const handleDelete = (notificationId) => {
    dispatch(deleteNotification(notificationId));
  };

  return (
    <div className="main-content split-content page-notifications">
      <div className="split-content-wrapper">
        <Container fluid>
          <NotificationsHeader />
          <div className="content-wrapper notifications-wrapper">
            {notifications.length > 0 ? (
              <Table className="notifications-list" responsive>
                <tbody>
                  {notifications.map(notification => (
                    <NotificationsItem
                      key={notification.id}
                      notification={notification}
                      handleMarkAsRead={handleMarkAsRead}
                      handleMarkAsUnread={handleMarkAsUnread}
                      handleDelete={handleDelete}
                    />
                  ))}
                </tbody>
              </Table>
            ) : (
              <>
                {!notificationsLoading && (
                  <NothingFound text={intl.formatMessage({ defaultMessage: `You don't have any notifications yet` })} />
                )}
              </>
            )}
            {notificationsLoading ? (
              <Loading />
            ) : (
              <Waypoint
                bottomOffset="-50px"
                onEnter={() => { loadMore(); }}
              />
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  notifications: state.Notifications.notifications,
  notificationsLoading: state.Notifications.loading,
});

Notifications.propTypes = {
  dispatch: PropTypes.func.isRequired,
  notifications: PropTypes.array.isRequired,
  notificationsLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Notifications);
